import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../mui-theme-design';
import { makeStyles } from "@mui/styles";
import { Refresh } from '@mui/icons-material';
import Roster_Import from './ImportTemplates/ImportRoster'
import Time_Import from './ImportTemplates/ImportTimeEntry'
import PTO_Import from './ImportTemplates/ImportPTO'
import PO_Import from './ImportTemplates/ImportPO'
import Rates_Import from './ImportTemplates/ImportRates'

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .MuiButton-root": {
            fontSize: "0.7rem"
        },
    },
    indicator: {
        background: "none"
    },
    tabs: {
        "& button[aria-selected='true']": {
            border: "3px solid red"
        }
    },
}));

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
 

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ImportTabs() {
    const [value, setValue] = React.useState(0);
    const [refresh, setRefresh] = React.useState(false);
    const classes = pageStyles();
    const [runRoster, setRunRoster] = React.useState(false);
    const [openReport, setOpenReport] = React.useState(true);
    const [propString, setPropString] = React.useState('');
    // var propString;
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
  /*  const handleRosterCallback = (childData) => {
             
 //       console.log(`roster config callback`, childData);
        setPropString(childData)      
   //     console.log(`PropString`, propString)
        setRunRoster(true)
        setOpenReport(true)
        setRefresh(true)
     //   runReport(propString)
        
       
    };
    const handleClearRoster = () => {

   //      console.log(`ClearRoster`);
        setOpenReport(false)
        setPropString('')
        setRunRoster(false)
        setRefresh(false)

        //   runReport(propString)


    };*/
    function runReport(propString) {
        setOpenReport(true)
    //    console.log(`checkString`, propString)
    //    console.log(`checkRun`, runRoster)
       setRefresh(false)
   //     ReportUserRoster(propString)
    }

    React.useEffect(() => {
 //       console.log(`useEffect RunR`, runRoster)
 //       console.log(`useEffect Refrsh`, refresh)
 //       console.log(`useEffect String`, propString)
     
        if (refresh) {
            if (runRoster) {

               /* console.log(`refresh reportTab`, propString)
                runReport(propString)*/
            }
        }
    
        setRefresh(false)
     //   setRunRoster(false)
    })

    // variant="fullWidth"
    return (
        <MuiThemeProvider theme={muiThemeDesign}>

        <Box sx={{ width: '100%' }}>
                <Box className={classes.root} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs  value={value} onChange={handleChange} aria-label="ReportsTab"  sx={{paddingTop: {xs:8, sm:8, md: 8, lg:8, xl: 8}}}>
                        <Tab label="Import" {...a11yProps(0)} />
                     {/*   <Tab label="Time/Billing" {...a11yProps(1)} />
                        <Tab label="Site Mgt" {...a11yProps(2)} />*/}
                                     
                </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <MuiThemeProvider theme={muiThemeDesign}>
                        <Grid container rowSpacing={1} columnSpacing={1} className={classes.root}>
                        <Grid item xs={2}>                      
                            <Roster_Import  />
                        </Grid>
                        <Grid item xs={2}>
                                <Time_Import />
                            </Grid>
                            <Grid item xs={2}>

                                <PTO_Import />
                            </Grid>
                            <Grid item xs={2}>

                                <PO_Import />
                            </Grid>
                             <Grid item xs={2}>

                                <Rates_Import />
                            </Grid>
                           
                        </Grid>
                    </MuiThemeProvider>
                    </TabPanel>
              
               
               
            </Box>
        </MuiThemeProvider>
    );
}